import React from "react";
import { observer } from "mobx-react";
import locale from "@bonliva-crm/locale";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Form } from "@modules/formx-react";
import DnDContainer from "@containers/DnDContainer/DnDContainer";
import { DynamicFieldsGroup } from "@consultants/ConsultantContract/DynamicFieldsGroup";
import { FormxDebugger } from "@common/formx";
import { ThemeType } from "@theme";
import { ContractTableStore } from "../SnapshotsTableStore";

type Props = {
  anchorEl: any;
  onClose: () => void;
  onClear: () => void;
  onSubmit: () => void;
  store: ContractTableStore;
};

export const UploadSignedContractPopover = observer((props: Props) => {
  const { store } = props;
  const classes = useStyles({});

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>{locale.ChooseSignedContract}</DialogTitle>

      <DialogContent dividers>
        <Form store={store.form} allowUpdates>
          <DnDContainer
            onDrop={(accepted) => {
              if (accepted[0]) {
                store.fileToUpload = accepted[0];
              }
            }}
            style={{
              margin: "-16px -24px",
              padding: "16px 24px"
            }}
            overlayProps={{ className: classes.overlay }}
          >
            <Grid container spacing={2}>
              {store.fileToUpload && (
                <Grid item xs={12}>
                  <Typography>{store.fileToUpload.name}</Typography>
                </Grid>
              )}

              <Grid item xs={12}>
                <DynamicFieldsGroup
                  form={store.form}
                  fields={store.fields}
                  gridContainerProps={{ spacing: 4 }}
                  extraProps={{
                    store,
                    contractTypeToUpload: store.contractToUpload?.Type
                  }}
                />
              </Grid>
            </Grid>
          </DnDContainer>
        </Form>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={props.onClose}>
          {locale.Cancel}
        </Button>

        <Button onClick={props.onClear} disabled={!store.fileToUpload} variant="outlined">
          {locale.Reset}
        </Button>

        <Button
          color="primary"
          variant="contained"
          disabled={!!store.fileToUpload}
          onClick={store.requestUpload}
          style={{ marginLeft: "auto" }}
        >
          {locale.UploadFile}
        </Button>

        <Button
          color="primary"
          variant="contained"
          disabled={!store.fileToUpload || !store.form.valid || store.loading}
          onClick={() => store.onSubmit(() => props.onSubmit())}
        >
          {locale.Save}
        </Button>
      </DialogActions>

      <FormxDebugger store={store.form} />
    </Dialog>
  );
});

const useStyles = makeStyles((theme: ThemeType) => ({
  overlay: {
    // marginBottom: "0 !important"
  }
}));
